<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{'dashboard.greetings' | translate}}, {{userDetail.name}}" *ngIf="!loader">
  <ng-template #addButton>
    <button mat-flat-button color="accent" (click)="createNewBusiness()">
      Create new business
      <mat-icon class="material-icons-round" [inline]="true"
        >add_circle</mat-icon
      >
    </button>
  </ng-template>
</sm-title-bar>
<sm-stat-cards></sm-stat-cards>

<div class="row gx-4 mt-4" *ngIf="!loader">
  <div class="col-lg-12">
    <sm-latest-notifications></sm-latest-notifications>
  </div>
  <div class="col-lg-12">
    <sm-latest-messages></sm-latest-messages>
  </div>
  
</div>

<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>